import React, { ReactNode } from "react";
import classNames from "classnames";

type StepProps = {
  isActive?: boolean;
  children: string;
  sectionKey: string;
  setActiveSectionKey: (sectionKey: string) => void;
};

const Step = ({
  children,
  isActive,
  sectionKey,
  setActiveSectionKey,
}: StepProps) => {
  return (
    <button
      className="all:unset t-group t-relative t-pl-1 t-max-w-full t-cursor-pointer t-select-none"
      onClick={() => setActiveSectionKey(sectionKey)}
      type="button"
    >
      {isActive && (
        <span className="t-absolute -t-left-px t-top-1 t-bottom-1 t-w-0.5 t-bg-purple-40" />
      )}
      <span className="t-block t-px-2 t-py-1 t-rounded-md group-hover:t-bg-surface-grey">
        <span
          className={classNames("t-text-subtext-sm t-line-clamp-2", {
            "t-text-purple": isActive,
            "t-text-text-60": !isActive,
          })}
        >
          {children}
        </span>
      </span>
    </button>
  );
};

export const FillFormStepper = ({ children }: { children: ReactNode }) => {
  return (
    <div className="t-flex t-flex-col t-gap-1 t-w-full t-border-0 t-border-l t-border-solid t-border-neutral-10">
      {children}
    </div>
  );
};

FillFormStepper.Step = Step;
